module.exports = __webpack_public_path__ + "img/clock-fill.ea8ff826.svg";